import { useState } from 'react';

import {
  Internship,
  DialogNugget,
  PanelNugget,
  AskLubavButtonEndpoint,
} from '@backrs_ui/common-ui';

import { handleInternshipApiCall } from '@backrs_ui/grow-ui/src/components/Nuggets/askLubavUtils/askLubav.internship.util';
import { handleBookmark } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';
import { useAppSelector, useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectBookmarkedNuggetId } from '@backrs_ui/grow-ui/src/redux/user/user';
import { ENVIRONMENT } from '@backrs_ui/grow-ui/src/settings';

import { Box, Dialog } from '@mui/material';

import { commonStyles } from './CommonStyles';

const GROW_URL = process.env.REACT_APP_GROW_URL;
const IS_PROD = ENVIRONMENT === 'production';

export type LubavInternship = Readonly<{
  relevance: string;
  metadata: Internship;
}>;

type InternshipFormatterProps = Readonly<{
  internships: LubavInternship[];
}>;

export const InternshipFormatter = ({ internships }: InternshipFormatterProps) => {
  const [open, setOpen] = useState(false);
  const [activeDialogNugget, setActiveDialogNugget] = useState<LubavInternship | null>(null);
  const [askLubavButtonResponse, setAskLubavButtonResponse] = useState<string | undefined>(
    undefined,
  );

  const bookmarkId = useAppSelector(
    selectBookmarkedNuggetId({
      nuggetId: Number(activeDialogNugget?.metadata.id),
      variant: 'internship',
    }),
  );

  const dispatch = useAppDispatch();

  const user = useAppSelector((state) => state.user.user);
  const mostRecentResponseSetTrack = useAppSelector((state) => state.userResponseSet.results?.tier);
  const enableAllLubavOptions = !IS_PROD || user?.roles?.some((role) => role.name === 'Lubav Beta');

  const dialogNugget = activeDialogNugget ? (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
      <DialogNugget
        shareParams={
          GROW_URL
            ? {
                title: `Prosper: ${activeDialogNugget.metadata?.role_title}`,
                text: `Prosper: ${activeDialogNugget.metadata?.ai_description}`,
                url: `${GROW_URL}?internship=${activeDialogNugget.metadata?.id}`,
              }
            : undefined
        }
        title={activeDialogNugget?.metadata.role_title}
        titleOnClick={() => window.open(activeDialogNugget?.metadata.application_url, '_blank')}
        subTitle={activeDialogNugget?.metadata.company}
        variant={{
          type: 'internship',
          internshipInfo: activeDialogNugget?.metadata,
          askLubavButtonGroupProps: {
            isDialogOpen: true,
            tier: mostRecentResponseSetTrack,
            enableAllOptions: enableAllLubavOptions,
            user: user,
            handleApiCall: (url_key: AskLubavButtonEndpoint) =>
              handleInternshipApiCall({
                url_key,
                userId: user?.id,
                internship: activeDialogNugget?.metadata || null,
                askLubavResponseAccumulator: (chunk) =>
                  setAskLubavButtonResponse((prev) => (prev || '') + chunk),
                setAskLubavButtonResponse,
              }),
          },
          askLubavButtonResponse,
        }}
        description=""
        columnCategory={activeDialogNugget?.metadata.role_type || 'Internship'}
        customMenuActions={[
          {
            icon: 'IconApply',
            text: 'Apply',
            onClick: () => window.open(activeDialogNugget?.metadata.application_url, '_blank'),
          },
        ]}
        saveToLibrary={() =>
          handleBookmark({
            nuggetId: activeDialogNugget?.metadata.id,
            dispatch,
            bookmarkId,
            variant: 'internship',
          })
        }
        hasBookmarkedNugget={!!bookmarkId}
      />
    </Dialog>
  ) : null;

  return (
    <>
      {dialogNugget}
      <Box sx={commonStyles.nuggetList}>
        {internships.map((internship) => (
          <PanelNugget
            key={internship.metadata.id}
            title={internship.metadata.role_title}
            subTitle={internship.metadata.company}
            subText={internship.relevance}
            size="SMALL"
            onClick={() => {
              setActiveDialogNugget(internship);
              setOpen(true);
            }}
            variant={{
              type: 'internship',
              internshipInfo: internship.metadata,
              askLubavButtonResponse,
            }}
          />
        ))}
      </Box>
    </>
  );
};
